import { GetVmcTechnicalResponseSchema } from '@shared/schema/vmc.technical.schema'
import { queryOptions } from '@tanstack/react-query'

import { type QueryOptionsData } from '@/@types/query'
import { apiFetch } from '@/lib/api-fetch'

// Clé partagée avec la mutation de configuration, qui écrit sa réponse directement dans le cache du site
// (cf. useSaveVmcConfiguration) plutôt que d'invalider.
export function vmcTechnicalQueryKey(siteId: number) {
  return ['vmc', 'technical', siteId] as const
}

// État du synoptique VMC d'un site : bâtiments, étages ordonnés du haut vers le bas, VMC de chaque étage
// et VMC rattachées à aucun étage. Sert les deux onglets — la coupe illustrée et la page de configuration,
// qui consomment exactement les mêmes données. La réponse est cloisonnée côté API (société + user_site).
export function vmcTechnicalQuery(siteId: number) {
  return queryOptions({
    queryKey: vmcTechnicalQueryKey(siteId),
    async queryFn() {
      const rawResponse = await apiFetch.get(`site/${siteId}/vmc/technical`)

      if (!rawResponse.ok) {
        throw new Error('Failed to fetch VMC technical view')
      }

      try {
        return await GetVmcTechnicalResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse VMC technical response', { cause: error })
      }
    },
  })
}

export type VmcTechnical = QueryOptionsData<ReturnType<typeof vmcTechnicalQuery>>
